import { ChecklistItem } from '@models/checklist';

export const sortItems = (items: ChecklistItem[]): ChecklistItem[] => {
	const sortedItems: ChecklistItem[] = [];

	const headNode = items.find((item) => item.headNode);

	if (!headNode) return items;

	let nextNodeId = headNode.nextNodeId;

	sortedItems.push(headNode);

	while (nextNodeId) {
		const nextItem = items.find((item) => item.id === nextNodeId);
		if (!nextItem) break;
		sortedItems.push(nextItem);
		nextNodeId = nextItem.nextNodeId;
	}

	return sortedItems;
};
